<template>
  <!-- 产品报价 -->
  <div class="productMake">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" @click="handleAdd" style="margin-top: 5px"
        >新增</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel"
            ><a-icon type="primary" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>
    <a-table
      ref="table"
      rowKey="id"
      :scroll="{ x: 1800, y: 280 }"
      :columns="productMake"
      :dataSource="productMakeMessage"
      :pagination="ipagination"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record.id)">删除</a>
      </span>
    </a-table>

    <productMakeModel ref="modalForm" @ok="modalFormOk"></productMakeModel>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage';
import productMakeModel from './productMakeModel.vue';
import customRender from '@/utils/customRender.js';
// 产品报价

const productMake = [
  {
    title: '收益率(%)',
    dataIndex: 'expectedYield',
    align: 'center',
    with: 80,
  },
  {
    title: '下一开放日',
    dataIndex: 'nextOpenDate',
    align: 'center',
    customRender: customRender,
    with: 200,
  },
  {
    title: '下一赎回日',
    dataIndex: 'nextRedemptionDate',
    align: 'center',
    customRender: customRender,
    with: 200,
  },
  {
    title: '结息日',
    align: 'center',
    dataIndex: 'endDate',
    with: 200,
  },
  {
    title: '起息日',
    align: 'center',
    dataIndex: 'beginDate',
    with: 200,
  },
  {
    title: '到期日',
    align: 'center',
    dataIndex: 'dueDate',
    customRender: customRender,
    with: 200,
  },
  {
    title: '申购日',
    align: 'center',
    dataIndex: 'purchaseDate',
    customRender: customRender,
    with: 200,
  },
  {
    title: '赎回日',
    align: 'center',
    dataIndex: 'redemptionDate',
    customRender: customRender,
    with: 200,
  },
  {
    title: '下一个申购日',
    align: 'center',
    dataIndex: 'nextPurchaseDate',
    width: 200,
    customRender: customRender,
  },
  {
    title: '预期开放日',
    align: 'center',
    dataIndex: 'openDate',
    customRender: customRender,
    with: 200,
  },

  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode',
    with: 80,
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
    width: 120,
  },
];
export default {
  data() {
    return {
      productMake,
      visible: false, //弹窗开关
      loading: false,
      width: 1400,
      title: '当前位置:产品报价',
      selectedRowKeys: [],
      selectionRows: [],
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      url: {
        list:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/list', //查询
        delete:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/delete', //删除
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productQuotation/deleteBatch', //删除
      },
      dataSource: [],
      productMakeMessage: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
    };
  },
  created() {
    this.getList();
  },
  components: {
    productMakeModel,
  },
  methods: {
    getList() {
      let fundCode = this.$route.query.fundCode;
      let that = this;
      getAction(that.url.list, { fundCode: fundCode }).then((res) => {
        this.productMakeMessage = res.result.list;
        console.log(res);
      });
    },
    handleAdd(course) {
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }
      this.$refs.modalForm.add(course);
    },
    handleCancel() {
      this.visible = false;
    },
    //删除
    handleDelete(id) {
      console.log(id);
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.getList(1);
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    // 批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        // this.isorter.column = sorter.field;
        // this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.getList();
    },
    handleEdit(record) {
      // 编辑
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
    },
  },
};
</script>

<style></style>
